import { useState, useEffect, useContext } from "react";
import {PieChart} from 'amazing-react-charts'
import Select from "react-select";
import { NavLink as RRNavLink } from "react-router-dom";
import { CLOSE_IMAGE } from "../Image";
import {DATATABLE_USUARIOS} from "../Datatables";
import { UsuariosModal,DeleteModal} from "../Modal";
import StoreContext from "../Store/Context";
import {MDBIcon,MDBTabs,MDBTabsItem,MDBTabsLink, MDBTabsContent,MDBTabsPane,MDBInput,MDBBtn} from "mdb-react-ui-kit";

import {put_compania,get_usr_usuario, post_usr_usuario, put_usr_usuario,put_usr_usuario_sts,get_compania_all,folios_restantes} from "../Services";
import { Container, Row, Col, NavLink,Button,ButtonGroup } from "reactstrap";

export const ConpaniaP = () => {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [iconsActive, setIconsActive] = useState("tab1");
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };
  return (
    <div className="cfg-admin font-s12px">
<header className="cfg-header">

    <div className="cfg-header-info">
      <h1 className="cfg-title">Administración</h1>
      <p className="cfg-subtitle">Configuración del sistema</p>
    </div>

    <MDBTabs className="cfg-tabs">

      <MDBTabsItem>
        <MDBTabsLink
          onClick={() => handleIconsClick("tab1")}
          active={iconsActive === "tab1"}
        >
          <MDBIcon fas icon="building" className="me-2" />
          Compañía
        </MDBTabsLink>
      </MDBTabsItem>

      <MDBTabsItem>
        <MDBTabsLink
          onClick={() => handleIconsClick("tab2")}
          active={iconsActive === "tab2"}
        >
          <MDBIcon fas icon="user-friends" className="me-2" />
          Usuarios
        </MDBTabsLink>
      </MDBTabsItem>

      <MDBTabsItem>
        <MDBTabsLink
          onClick={() => handleIconsClick("tab3")}
          active={iconsActive === "tab3"}
        >
          <MDBIcon fas icon="file-invoice" className="me-2" />
          Folios FE
        </MDBTabsLink>
      </MDBTabsItem>

    </MDBTabs>

    <NavLink
      tag={RRNavLink}
      to="/user/home"
      className="cfg-close"
      title="Cerrar"
    >
      <img src={CLOSE_IMAGE} alt="Cerrar" />
    </NavLink>

  </header>
      <MDBTabsContent className="cfg-content">
        <MDBTabsPane show={iconsActive === "tab1"} >
          <Compania/>
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab2"}>
          <Usuarios setError={setError} error={error} setBasicModal={setBasicModal} basicModal={basicModal} basicModalDelete={basicModalDelete} setBasicModalDelete={setBasicModalDelete}
           basicModalEdit={basicModalEdit} setBasicModalEdit={setBasicModalEdit} isLoading={isLoading} setLoading={setLoading} />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab3"}>
          <Folios setError={setError} error={error} setBasicModal={setBasicModal} basicModal={basicModal} basicModalDelete={basicModalDelete} setBasicModalDelete={setBasicModalDelete}
           basicModalEdit={basicModalEdit} setBasicModalEdit={setBasicModalEdit} isLoading={isLoading} setLoading={setLoading} />
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
};
function Compania() {
  const { dataCompania } = useContext(StoreContext);
  const [error, setError] = useState("");
  const [dataObjCompania, setObjCompania] = useState([]);
  const [sucursalSelected, setSucursal] = useState("");
  const [dataCompaniaObj, setDataCompania] = useState({
    com_id:"",
    com_nombre: "",
    com_alias:"",
    com_ruc: "",
    com_dv: "",
    com_direccion: "",
    com_telefono: "",
    com_telefono2: "",
    com_email: "",
    com_fax: "",
    com_web: "",
    com_info_interes:"",
    com_cotizacion_info:"",
    com_cot_image:"",
    com_res_image:"",
    com_instagram:"",
    com_tiktok:"",
    com_facebook:"",
    com_existencia_v:""
  });

  const onClickUpdateCompania = () => {
    var body = {
      com_nombre: dataCompaniaObj.com_nombre,
      com_alias:dataCompaniaObj.com_alias,
      com_ruc: dataCompaniaObj.com_ruc,
      com_dv: dataCompaniaObj.com_dv,
      com_direccion: dataCompaniaObj.com_direccion,
      com_telefono: dataCompaniaObj.com_telefono,
      com_telefono2: dataCompaniaObj.com_telefono2,
      com_email: dataCompaniaObj.com_email,
      com_fax: dataCompaniaObj.com_fax,
      com_web: dataCompaniaObj.com_web,
      com_info_interes:dataCompaniaObj.com_info_interes,
      com_cotizacion_info:dataCompaniaObj.com_cotizacion_info,
      com_cot_image:dataCompaniaObj.com_cot_image,
      com_instagram:dataCompaniaObj.com_instagram,
      com_tiktok:dataCompaniaObj.com_tiktok,
      com_facebook:dataCompaniaObj.com_facebook,
      com_id:dataCompaniaObj.com_id,
      com_existencia_v:dataCompaniaObj.com_existencia_v
    };

    var result = put_compania(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCompania();
      else
        setError("ERROR "+data);
    })
  };
  async function fetchCompania() {
    var response;
    var result;
    var flag_result = false;
    // if(usr_perfil==="1"){
      response = await get_compania_all();
      setObjCompania(response);
      if(dataCompaniaObj.com_id.length>0){
      result = response.filter((data)=>{
        if(data.com_id === dataCompaniaObj.com_id){
            flag_result = false;
            return data
        }
        return null
      })
      }
      else{
        result = response[0];
        flag_result = true;
      }
      if(!flag_result){
        result = result[0];
      }
       setDataCompania({
        com_nombre: result.com_nombre,
        com_alias:result.com_alias,
        com_ruc: result.com_ruc,
        com_dv: result.com_dv,
        com_direccion: result.com_direccion,
        com_telefono: result.com_telefono,
        com_telefono2: result.com_telefono2,
        com_email: result.com_email,
        com_fax: result.com_fax,
        com_web: result.com_web,
        com_info_interes:result.com_info_interes,
        com_cotizacion_info:result.com_cotizacion_info,
        com_cot_image:result.com_cot_image,
        com_instagram:result.com_instagram,
        com_tiktok:result.com_tiktok,
        com_facebook:result.com_facebook,
        com_id:result.com_id,
        com_existencia_v:result.com_existencia_v
      });
      setSucursal(result.com_alias)
  }

  function onChange(event) {
    const { value, name } = event.target;
    setDataCompania({
      ...dataCompaniaObj,
      [name]: value,
    });
  }

  useEffect(() => {
    fetchCompania();
  }, []);

  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setDataCompania({
      ...dataCompaniaObj,
      [name]:value==="0"?"1":"0"
  })};
  var objCompania = []
    dataObjCompania.map((comp) => {
    objCompania.push({
      value: comp.com_id,
      label: comp.com_alias,
    });
    return comp;
  });
  const onChangeDropdown = (selectedOptions) => {
    dataObjCompania.find((data)=>{
      if(data.com_id === selectedOptions.value){
        setDataCompania({
          com_nombre: data.com_nombre,
          com_alias: data.com_alias,
          com_ruc: data.com_ruc,
          com_dv: data.com_dv,
          com_direccion: data.com_direccion,
          com_telefono: data.com_telefono,
          com_telefono2: data.com_telefono2,
          com_email: data.com_email,
          com_fax: data.com_fax,
          com_web: data.com_web,
          com_info_interes:data.com_info_interes,
          com_cotizacion_info:data.com_cotizacion_info,
          com_cot_image:data.com_cot_image,
          com_instagram:data.com_instagram,
          com_tiktok:data.com_tiktok,
          com_facebook:data.com_facebook,
          com_id:data.com_id,
          com_existencia_v:data.com_existencia_v
        })
      }
    })
  };

return (
  <fluid className="company-config-page font-s12px">
    <div className="cc-toolbar">
      <div className="cc-select">
        {objCompania.length > 1 ? (
          <Select
            options={objCompania}
            onChange={onChangeDropdown}
            placeholder={sucursalSelected}
          />
        ) : ""}
      </div>
      <MDBBtn
        className="cc-save-btn"
        type="submit"
        onClick={() => onClickUpdateCompania()}
      >
        <MDBIcon fas icon="save" className="me-2" />
        Guardar
      </MDBBtn>
    </div>
    {error && error.length > 0 ? ( <div className="cc-error">{error}</div> ) : null}
    <section className="cc-card cc-modern-card">
      <div className="cc-modern-header">
        <div className="cc-modern-icon">
          <MDBIcon fas icon="building" />
        </div>
        <div>
          <h3 className="cc-section-title">DATOS GENERALES</h3>
          <p className="cc-modern-subtitle">
            Información fiscal y comercial de la empresa.
          </p>
        </div>
      </div>
  <div className="cc-modern-divider" />
  <Row className="g-3">
    <Col sm={6}>
      <MDBInput
        id="com_nombre"
        name="com_nombre"
        label="Razón Social"
        onChange={onChange}
        value={dataCompaniaObj.com_nombre}
        disabled/>
    </Col>
    <Col sm={6}>
      <MDBInput
        id="com_alias"
        name="com_alias"
        label="Razón comercial"
        onChange={onChange}
        value={dataCompaniaObj.com_alias}
        disabled />
    </Col>
    <Col xs={9} sm={4} md={3}>
      <MDBInput
        id="com_ruc"
        name="com_ruc"
        label="RUC"
        onChange={onChange}
        value={dataCompaniaObj.com_ruc}
        disabled/>
    </Col>
    <Col xs={3} sm={2} md={2}>
      <MDBInput
        id="com_dv"
        name="com_dv"
        label="DV"
        onChange={onChange}
        value={dataCompaniaObj.com_dv}
        disabled />
    </Col>
    <Col sm={6} md={7}>
      <MDBInput
        id="com_web"
        name="com_web"
        label="Página Web"
        onChange={onChange}
        value={dataCompaniaObj.com_web}/>
    </Col>
    <Col sm={12} md={6}>
      <MDBInput
        id="com_email"
        name="com_email"
        label="EMAIL"
        onChange={onChange}
        value={dataCompaniaObj.com_email}/>
    </Col>
    <Col sm={dataCompania.com_version === "2" ? 8 : 12}  md={dataCompania.com_version === "2" ? 9 : 12}>
      <div className="cc-modern-textarea-field">
        <span className="cc-modern-label">Dirección</span>
        <textarea
          id="com_direccion"
          name="com_direccion"
          rows={1}
          className="cc-modern-textarea"
          onChange={onChange}
          value={dataCompaniaObj.com_direccion || ""}
        />
      </div>
    </Col>
  </Row>
</section>

<section className="cc-card cc-modern-card">
  <div className="cc-modern-header">
    <div className="cc-modern-icon">
      <MDBIcon fas icon="address-book" />
    </div>
    <div>
      <h3 className="cc-section-title">CONTACTO Y REDES</h3>
      <p className="cc-modern-subtitle">
        Teléfonos y redes sociales de la empresa.
      </p>
    </div>
  </div>
  <div className="cc-modern-divider" />
  <Row className="g-3">
    <Col xs={6} md={4}>
      <MDBInput
        id="com_telefono"
        name="com_telefono"
        label="Teléfono"
        onChange={onChange}
        value={dataCompaniaObj.com_telefono}/>
    </Col>
    <Col xs={6} md={4}>
      <MDBInput
        id="com_telefono2"
        name="com_telefono2"
        label="Teléfono 2"
        onChange={onChange}
        value={dataCompaniaObj.com_telefono2}/>
    </Col>
    <Col xs={6} md={4}>
      <MDBInput
        id="com_fax"
        name="com_fax"
        label="FAX"
        onChange={onChange}
        value={dataCompaniaObj.com_fax} />
    </Col>
    <Col xs={6} md={4}>
      <MDBInput
        id="com_facebook"
        name="com_facebook"
        label="Facebook"
        onChange={onChange}
        value={dataCompaniaObj.com_facebook}/>
    </Col>
    <Col xs={6} md={4}>
      <MDBInput
        id="com_instagram"
        name="com_instagram"
        label="Instagram"
        onChange={onChange}
        value={dataCompaniaObj.com_instagram} />
    </Col>
    <Col xs={6} md={4}>
      <MDBInput
        id="com_tiktok"
        name="com_tiktok"
        label="TikTok"
        onChange={onChange}
        value={dataCompaniaObj.com_tiktok}/>
    </Col>
  </Row>
</section>
<section className="cc-card cc-modern-card">
  <div className="cc-modern-header">
    <div className="cc-modern-icon">
      <MDBIcon fas icon="file-invoice" />
    </div>
    <div>
      <h3 className="cc-section-title">FACTURACIÓN Y DIRECCIÓN</h3>
      <p className="cc-modern-subtitle">
        Configuración de ventas y datos impresos en la factura.
      </p>
    </div>
  </div>
  <div className="cc-modern-divider" />
  <Row className="g-3 align-items-stretch">
    {dataCompania.com_version === "2" && (
      <Col sm={4} md={3}>
        <div className="cc-modern-setting">
          <div className="cc-modern-setting-text">
            <strong>Facturar sin existencia</strong>
            <span>
              Permite realizar ventas aunque el artículo no tenga existencia disponible.
            </span>
          </div>
          <ButtonGroup className="cc-toggle-group">
            <Button
              color="primary"
              onClick={() =>
                setDataCompania({
                  ...dataCompaniaObj,
                  com_existencia_v: "1"
                })
              }
              active={dataCompaniaObj.com_existencia_v === "1"}
            >
              SI
            </Button>
            <Button
              color="primary"
              onClick={() =>
                setDataCompania({
                  ...dataCompaniaObj,
                  com_existencia_v: "0"
                })
              }
              active={dataCompaniaObj.com_existencia_v === "0"}
            >
              NO
            </Button>
          </ButtonGroup>

        </div>
      </Col>
    )}
    <Col xs={12}>
      <div className="cc-modern-textarea-field">
        <span className="cc-modern-label">
          Información en la factura
        </span>
        <textarea
          id="com_info_interes"
          name="com_info_interes"
          rows={window.innerWidth <= 611 ? 3 : 4}
          className="cc-modern-textarea"
          onChange={onChange}
          value={dataCompaniaObj.com_info_interes || ""}/>
      </div>
    </Col>
  </Row>
</section>
<section className="cc-card cc-cot-card">
  <div className="cc-cot-header">
    <div className="cc-cot-icon">
      <MDBIcon fas icon="file-alt" />
    </div>
    <div>
      <h3 className="cc-section-title">COTIZACIONES</h3>
      <p className="cc-cot-subtitle">
        Configura las opciones y la información que aparecerá en tus cotizaciones.
      </p>
    </div>
  </div>
  <div className="cc-cot-divider" />
  <label className="cc-cot-option">
    <input
      type="checkbox"
      name="com_cot_image"
      value={dataCompaniaObj.com_cot_image}
      onChange={handleOnChangeCheckBox}
      checked={dataCompaniaObj.com_cot_image === "1"}
    />
    <span className="cc-cot-checkbox">
      <MDBIcon fas icon="check" />
    </span>
    <div className="cc-cot-option-text">
      <strong>Mostrar cotización con imagen</strong>
      <span>
        Incluye las imágenes de los productos en la cotización.
      </span>
    </div>
  </label>
  <div className="cc-cot-field">
    <div className="cc-cot-label">
      Información en las cotizaciones
      <MDBIcon
        fas
        icon="info-circle"
        className="ms-2"
      />
    </div>
    <textarea
      id="com_cotizacion_info"
      name="com_cotizacion_info"
      className="cc-cot-textarea"
      maxLength={500}
      rows={1}
      onChange={onChange}
      value={dataCompaniaObj.com_cotizacion_info || ""}
    />
    <div className="cc-cot-counter">
      {(dataCompaniaObj.com_cotizacion_info || "").length} / 500 caracteres
    </div>
  </div>
  <div className="cc-cot-tip">
    <span className="cc-cot-tip-icon">
      <MDBIcon fas icon="lightbulb" />
    </span>
    <div>
      <strong>Sugerencia:</strong>{" "}
      Puedes incluir promociones, políticas de pago o cualquier información
      adicional que desees que vea tu cliente.
    </div>
  </div>
</section>
  </fluid>
);
}
function Usuarios({setError,error,basicModal,setBasicModal,setBasicModalDelete,basicModalDelete,basicModalEdit,setBasicModalEdit,isLoading,setLoading}) {
  const [dataUsuarios, setDataUsuarios] = useState([]);
  const [formUsuarios, setFormUsuarios] = useState({
    usr_id: "",
    usr_usuario: "",
    usr_clave: "",
    usr_nombre: "",
    usr_perfil: "",
    usr_sucursal: "",
    usr_print:"",
    usr_company:"",
    usr_ajustes:"",
    usr_factura:"",
    usr_inventario:"",
    usr_cotizacion:"",
    usr_articulo:"",
    usr_reporte:"",
    usr_fac_compra:"",
    usr_movimiento:"",
    usr_hacer_inventario:"",
    usr_trazabilidad:"",
    usr_a_costo:"",
    usr_apartado:"",
    usr_gastos:"",
    dataCompaniaObj:[],
    cajaData:[],
    usr_clientes:"",
    usr_precio:""
  });

  const onClickUpdateUsuarios = () => {
    setLoading(true)
    var body ={
       usr_id: formUsuarios.usr_id,
        usr_usuario: formUsuarios.usr_usuario,
    usr_clave:  formUsuarios.usr_clave,
    usr_nombre:  formUsuarios.usr_nombre,
    usr_perfil:  formUsuarios.usr_perfil,
    usr_sucursal:  formUsuarios.usr_sucursal,
    usr_print: formUsuarios.usr_print,
    usr_company: formUsuarios.usr_company,
    usr_ajustes: formUsuarios.usr_ajustes,
    usr_factura: formUsuarios.usr_factura,
    usr_inventario: formUsuarios.usr_inventario,
    usr_cotizacion: formUsuarios.usr_cotizacion,
    usr_articulo: formUsuarios.usr_articulo,
    usr_reporte: formUsuarios.usr_reporte,
    usr_fac_compra: formUsuarios.usr_fac_compra,
    usr_movimiento: formUsuarios.usr_movimiento,
    usr_hacer_inventario: formUsuarios.usr_hacer_inventario,
    usr_trazabilidad: formUsuarios.usr_trazabilidad,
    usr_a_costo:formUsuarios.usr_a_costo,
    usr_apartado: formUsuarios.usr_apartado,
    usr_gastos:formUsuarios.usr_gastos,
    usr_clientes: formUsuarios.usr_clientes,
    usr_precio: formUsuarios.usr_precio,
    }
    var result = put_usr_usuario(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchUsuarios();
      }
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateUsuario_sts = () => {
    var body = {
      usr_id: formUsuarios.usr_id,
      usr_sts: 0,
    };
    var result = put_usr_usuario_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchUsuarios();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveUsuarios = () => {
    setLoading(true)
    if (
      formUsuarios.usr_usuario.length > 0 &&
      formUsuarios.usr_clave.length > 0 &&
      formUsuarios.usr_nombre.length > 0 &&
      formUsuarios.usr_print.length >0
    ) {
      var result = post_usr_usuario(formUsuarios);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false);
          fetchUsuarios();
        }
         
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchUsuarios() {
    setLoading(true);
    var response;
    response = await get_usr_usuario();
    setDataUsuarios(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormUsuarios({
      ...formUsuarios,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const onChangeDropdown = (selectedOptions) => {
    if(selectedOptions.objName==="print"){
      setFormUsuarios({
        ...formUsuarios,
        usr_print:selectedOptions.value
    })
    }
    else{
      setFormUsuarios({
        ...formUsuarios,
        usr_perfil:selectedOptions.value
    })
    }
    };

    const handleOnChangeCheckBox = (event) => {
      const { value, name } = event.target;
      setFormUsuarios({
        ...formUsuarios,
        [name]:value==="0"?"1":"0"
    })
    };
  return (
    <fluid  className="font-s12px  contenedor-tabla">
      {basicModal && (
        <UsuariosModal
          props={formUsuarios}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveUsuarios}
          toggleSaveEdit={onClickUpdateUsuarios}
          onChange={onChange}
          error={error}
          onChangeDropdown={onChangeDropdown}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          loading={isLoading}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formUsuarios.usr_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateUsuario_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Col className="modal-add-inventario datatable-factura css_datatable1 tabla-auto-height">
        <DATATABLE_USUARIOS dataUsuarios ={dataUsuarios} 
        setBasicModalDelete={setBasicModalDelete}
        setFormUsuarios={setFormUsuarios}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchUsuarios={fetchUsuarios}
        isLoading={isLoading} />
        </Col>
    </fluid>
  );
}
function Folios() {
  const [dataFolios, setDataFolios] = useState([]);
  async function fetchFolios() {
    var response = await folios_restantes();
    setDataFolios(response.FoliosRestantesResult);
  }

  useEffect(() => {

      fetchFolios()

  }, []);

return (
  <fluid  className="folios-page">

    {dataFolios !== undefined ? (
      <Row className="g-3">

        {/* ==============================
            DATOS
        ============================== */}
        <Col xs={12} md={8}>

          <section className="folios-card">

            <div className="folios-header">
              <div className="folios-header-icon">
                <MDBIcon fas icon="file-invoice" />
              </div>

              <div>
                <h3 className="folios-title">Folios electrónicos</h3>
                <p className="folios-subtitle">
                  Estado de licencia, ciclo y disponibilidad de folios
                </p>
              </div>
            </div>

            <div className="folios-divider" />


            {/* ESTADO GENERAL */}
            <div className="folios-section-title">
              Estado general
            </div>

            <Row className="g-3">

              <Col xs={4} sm={3} md={3}>
                <MDBInput
                  id="codigo"
                  name="codigo"
                  label="Código"
                  disabled
                  value={dataFolios.codigo}
                />
              </Col>

              <Col xs={8} sm={9} md={9}>
                <MDBInput
                  id="mensaje"
                  name="mensaje"
                  label="Mensaje"
                  disabled
                  value={dataFolios.mensaje}
                />
              </Col>

              <Col xs={12} sm={6}>
                <MDBInput
                  id="licencia"
                  name="licencia"
                  label="Licencia"
                  disabled
                  value={dataFolios.licencia}
                />
              </Col>

              <Col xs={6} sm={3}>
                <MDBInput
                  id="resultado"
                  name="resultado"
                  label="Resultado"
                  disabled
                  value={dataFolios.resultado}
                />
              </Col>

              <Col xs={6} sm={3}>
                <MDBInput
                  id="ciclo"
                  name="ciclo"
                  label="Ciclo"
                  disabled
                  value={dataFolios.ciclo}
                />
              </Col>

            </Row>


            <div className="folios-separator" />


            {/* FECHAS */}
            <div className="folios-section-title">
              Fechas
            </div>

            <Row className="g-3">

              <Col xs={12} sm={6}>
                <MDBInput
                  id="fechaCiclo"
                  name="fechaCiclo"
                  label="Fecha ciclo"
                  disabled
                  value={dataFolios.fechaCiclo}
                />
              </Col>

              <Col xs={12} sm={6}>
                <MDBInput
                  id="fechaLicencia"
                  name="fechaLicencia"
                  label="Fecha de licencia"
                  disabled
                  value={dataFolios.fechaLicencia}
                />
              </Col>

            </Row>


            <div className="folios-separator" />


            {/* RESUMEN DE FOLIOS */}
            <div className="folios-section-title">
              Resumen de folios
            </div>

            <Row className="g-3">

              <Col xs={6} sm={4} md={4}>
                <div className="folios-stat">
                  <span className="folios-stat-label">
                    Disponibles ciclo
                  </span>

                  <strong>
                    {dataFolios.foliosDisponibleCiclo}
                  </strong>
                </div>
              </Col>

              <Col xs={6} sm={4} md={4}>
                <div className="folios-stat">
                  <span className="folios-stat-label">
                    Utilizados ciclo
                  </span>

                  <strong>
                    {dataFolios.foliosUtilizadosCiclo}
                  </strong>
                </div>
              </Col>

              <Col xs={6} sm={4} md={4}>
                <div className="folios-stat">
                  <span className="folios-stat-label">
                    Folios totales
                  </span>

                  <strong>
                    {dataFolios.foliosTotales}
                  </strong>
                </div>
              </Col>

              <Col xs={6} sm={6} md={6}>
                <div className="folios-stat">
                  <span className="folios-stat-label">
                    Totales en ciclo
                  </span>

                  <strong>
                    {dataFolios.foliosTotalesCiclo}
                  </strong>
                </div>
              </Col>

              <Col xs={12} sm={6} md={6}>
                <div className="folios-stat folios-stat-primary">
                  <span className="folios-stat-label">
                    Total disponibles
                  </span>

                  <strong>
                    {dataFolios.foliosTotalesDisponibles}
                  </strong>
                </div>
              </Col>

            </Row>

          </section>

        </Col>


        {/* ==============================
            GRÁFICO
        ============================== */}
        <Col xs={12} md={4}>

          <section className="folios-card folios-chart-card">

            <div className="folios-header">
              <div className="folios-header-icon">
                <MDBIcon fas icon="chart-pie" />
              </div>

              <div>
                <h3 className="folios-title">
                  Distribución
                </h3>

                <p className="folios-subtitle">
                  Resumen gráfico de folios
                </p>
              </div>
            </div>

            <div className="folios-divider" />

            <div className="folios-chart">
              <PieChart
                legendType="scroll"
                colors={[
                  "#dd6864",
                  "#5093ce",
                  "#3366cc",
                  "#109618",
                  "#ff9900"
                ]}
                legendPosition="inside"
                radius="72%"
                toolboxTooltip={{
                  saveAsImage: "saving"
                }}
                title="Folios factura electrónica"
                center={["50%", "50%"]}
                data={[
                  {
                    name: "Total",
                    value: Number(dataFolios.foliosTotales)
                  },
                  {
                    name: "Total disponibles",
                    value: Number(dataFolios.foliosTotalesDisponibles)
                  },
                  {
                    name: "Totales en el ciclo",
                    value: Number(dataFolios.foliosTotalesCiclo)
                  },
                  {
                    name: "Utilizados en el ciclo",
                    value: Number(dataFolios.foliosUtilizadosCiclo)
                  },
                  {
                    name: "Disponibles ciclo",
                    value: Number(dataFolios.foliosDisponibleCiclo)
                  }
                ]}
              />
            </div>

          </section>

        </Col>

      </Row>
    ) : null}

  </fluid>
);
}